import { render, staticRenderFns } from "./blackListManager.vue?vue&type=template&id=703b2358&scoped=true&"
import script from "./blackListManager.vue?vue&type=script&lang=ts&"
export * from "./blackListManager.vue?vue&type=script&lang=ts&"
import style0 from "./blackListManager.vue?vue&type=style&index=0&id=703b2358&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b2358",
  null
  
)

export default component.exports